module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_3_before.jpg
// module id = 1198
// module chunks = 0